import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-information-dialog',
  templateUrl: './information-dialog.component.html',
  styleUrls: ['./information-dialog.component.scss'],
  imports: [CardComponent, MatButton, MatDialogClose],
})
export class InformationDialogComponent {
  dialogRef = inject(MatDialogRef<InformationDialogComponent>);
  data: { text: string; title: string; textStyle?: string } = inject(MAT_DIALOG_DATA);
}
